import AxiosService from "../AxiosService";

export class QuestionService {
  constructor() {
    this.service = new AxiosService();
  }

  addQuestion(clientId, surveyId, body) {
    return this.service.post(`/api/clients/${clientId}/surveys/${surveyId}/add-question`, body);
  }

  changeQuestion(clientId, surveyId, questionId, body) {
    return this.service.post(`/api/clients/${clientId}/surveys/${surveyId}/questions/${questionId}`, body);
  }

  resolveFutureQuestions(clientId, surveyId, questionId) {
    return this.service.get(`/api/clients/${clientId}/surveys/${surveyId}/future-questions/${questionId}`);
  }

  deleteAllSurveys(clientId, surveyId) {
    return this.service.delete(`/api/test/clients/${clientId}/surveys/${surveyId}`);
  }

  storeSurvey(clientId, surveyId, survey) {
    return this.service.post(`/api/test/clients/${clientId}/surveys`, {"surveyId": surveyId, questions: survey});
  }

  resolveFlow(clientId, surveyId) {
    return this.service.get(`/api/clients/${clientId}/surveys/${surveyId}/flow`);
  }

  resolveSurvey(clientId, surveyId) {
    return this.service.get(`/api/clients/${clientId}/surveys/${surveyId}`);
  }

  deleteQuestion(clientId, surveyId, questionId) {
    return this.service.delete(`/api/clients/${clientId}/surveys/${surveyId}/questions/${questionId}`);
  }
}